import { Command, CommandItem, CommandList } from '@ibsys/kit';
import { CheckIcon } from 'lucide-react';
import { FC } from 'react';
import { cn } from '@/shared/lib';

type Props = {
  /** Справочник, из которого выбирается значение блока */
  possibleValues: string[];
  /** Действующее значение блока; null — результат блока не значение, и отмечать в перечне нечего */
  checkedValue: string | null;
  isPending: boolean;
  onSelect: (value: string) => void;
};

/**
 * Выбор ручного значения блока из его справочника: выбранное сохраняется сразу.
 * Сам запрос ведёт окно правки — здесь только перечень значений.
 */
export const EvaluationBlockValueEditor: FC<Props> = ({ possibleValues, checkedValue, isPending, onSelect }) => (
  <Command shouldFilter={false}>
    <CommandList>
      {possibleValues.map((option) => (
        <CommandItem key={option} value={option} disabled={isPending} onSelect={() => onSelect(option)}>
          <CheckIcon className={cn('size-4', option === checkedValue ? 'opacity-100' : 'opacity-0')} />
          {option}
        </CommandItem>
      ))}
    </CommandList>
  </Command>
);
